import { useEffect } from 'react'
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import Layout from './components/Layout'
import { ProtectedRoute } from './components/ProtectedRoute'
import HomePage from './pages/HomePage'
import TestspielePage from './pages/TestspielePage'
import AddTestspielPage from './pages/AddTestspielPage'
import EquipmentPage from './pages/EquipmentPage'
import CartPage from './pages/CartPage'
import BusPage from './pages/BusPage'
import OrdersPage from './pages/OrdersPage'
import SupportPage from './pages/SupportPage'
import AdminPage from './pages/AdminPage'
import StoreManagerPage from './pages/StoreManagerPage'
import SimpleFileManagePage from './pages/SimpleFileManagePage'
import KartenPage from './pages/KartenPage'
import LoginPage from './pages/LoginPage'
import ResetPasswordPage from './pages/ResetPasswordPage'
import { initAuthListener } from './stores/authStore'
// Removed global CSS import for Netlify compatibility

const queryClient = new QueryClient()

function App() {
  useEffect(() => {
    // Initialize auth listener
    const unsubscribe = initAuthListener()
    
    // Cleanup function
    return () => {
      if (unsubscribe) {
        unsubscribe()
      }
    }
  }, [])

  return (
    <QueryClientProvider client={queryClient}>
      <Router>
        <Routes>
          {/* Öffentliche Routen */}
          <Route path="/login" element={<LoginPage />} />
          {/* Ziel des Recovery-Links. Bewusst ohne ProtectedRoute: dort werden
              Konten mit status 'pending'/'rejected' vollflächig gesperrt und
              könnten ihr Passwort nie zurücksetzen. */}
          <Route path="/reset-password" element={<ResetPasswordPage />} />
          
          {/* Geschützte Routes */}
          <Route path="/" element={
            <ProtectedRoute>
              <Layout>
                <HomePage />
              </Layout>
            </ProtectedRoute>
          } />
          <Route path="/testspiele" element={
            <ProtectedRoute>
              <Layout>
                <TestspielePage />
              </Layout>
            </ProtectedRoute>
          } />
          <Route path="/testspiele/add" element={
            <ProtectedRoute>
              <Layout>
                <AddTestspielPage />
              </Layout>
            </ProtectedRoute>
          } />
          <Route path="/equipment" element={
            <ProtectedRoute>
              <Layout>
                <EquipmentPage />
              </Layout>
            </ProtectedRoute>
          } />
          <Route path="/cart" element={
            <ProtectedRoute>
              <Layout>
                <CartPage />
              </Layout>
            </ProtectedRoute>
          } />
          <Route path="/bus" element={
            <ProtectedRoute>
              <Layout>
                <BusPage />
              </Layout>
            </ProtectedRoute>
          } />
          <Route path="/orders" element={
            <ProtectedRoute>
              <Layout>
                <OrdersPage />
              </Layout>
            </ProtectedRoute>
          } />
          <Route path="/support" element={
            <ProtectedRoute>
              <Layout>
                <SupportPage />
              </Layout>
            </ProtectedRoute>
          } />
          <Route path="/admin" element={
            <ProtectedRoute requireAdmin={true}>
              <Layout>
                <AdminPage />
              </Layout>
            </ProtectedRoute>
          } />
          <Route path="/store-manager" element={
            <ProtectedRoute requireAdmin={true}>
              <Layout>
                <StoreManagerPage />
              </Layout>
            </ProtectedRoute>
          } />
          <Route path="/dateiablage" element={
            <ProtectedRoute requireAdmin={true}>
              <Layout>
                <SimpleFileManagePage />
              </Layout>
            </ProtectedRoute>
          } />
          <Route path="/admin/karten" element={
            <ProtectedRoute requireAdmin={true}>
              <Layout>
                <KartenPage />
              </Layout>
            </ProtectedRoute>
          } />
          {/* Ohne diese Route rendert der Router bei einem unbekannten Pfad
              gar nichts — der Nutzer sieht eine komplett weisse Seite ohne
              jeden Hinweis. Genau das passiert einem Browser, der noch ein
              altes, gecachtes Bundle ausführt, in dem eine neue Route fehlt. */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </Router>
    </QueryClientProvider>
  )
}

export default App
